import React, { useEffect, useState } from 'react';
import { Paper, Box, Typography, Divider, Tab, Tabs, Button } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { Route, Switch, useHistory, useParams } from 'react-router-dom';
import SMSTemplateList from '../components/sms/SMSTemplateList';
import EmailTemplateList from '../components/email/EmailTemplateList';
import PrintTemplateList from '../components/print/PrintTemplateList';
import { useTranslation } from 'react-i18next';


const DEFAULT_TAB = 'sms';
const VALID_TABS = ['sms', 'email', 'print'];

const TemplateListView = () => {
  const [currentTab, setCurrentTab] = useState(DEFAULT_TAB);
  const { t } = useTranslation();
  const history = useHistory();
  const { tab } = useParams();
  const tabIsValid = VALID_TABS.indexOf(tab) > -1;

  useEffect(() => {
    if (!tab) {
      setCurrentTab('sms');
      history.push({ pathname: '/templates/' + DEFAULT_TAB});
    } else {
      setCurrentTab(tab);
    }
  }, [tab, history]);

  if (!tabIsValid) return <h1>{t('not-found')}</h1>;


  const handleChange = (event, newValue) => {
    setCurrentTab(newValue);
    history.push({ pathname: '/templates/' + newValue });
  };

  return (
    <>
      <Paper elevation={2}>
        <Box p={4} mb={4}>
          <Box display="flex">
            <Box flex={1}>
              <Typography variant="h4">{t('templates')}</Typography>
            </Box>
            <Box alignSelf="right">
              <Button
                variant="contained"
                color="primary"
                startIcon={<AddIcon />}
                onClick={() => history.push({ pathname: `/templates/${currentTab}/add` })}>
                {t(`add-${currentTab}-template`)}
              </Button>
            </Box>
          </Box>
          <Tabs
            value={currentTab}
            indicatorColor="primary"
            textColor="primary"
            onChange={handleChange}
            aria-label="template menu">
            <Tab label="SMS" value="sms" />
            <Tab label={t('email')} value="email" />
            <Tab label={t('print')} value="print" />
          </Tabs>
          <Divider />

          <Switch>
            <Route exact path={['/templates/sms']}>
              <SMSTemplateList />
            </Route>
            <Route path='/templates/email'>
              <EmailTemplateList />
            </Route>
            <Route path='/templates/print'>
              <PrintTemplateList />
            </Route>
          </Switch>

        </Box>
      </Paper>
    </>
  );
};


export default TemplateListView;
